import { config } from "@/config";
import type { BoxItem } from "@/services/types";
import { getToken, getUIDParam } from "@/services/utils";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export type PastBoxResponse = {
    products: BoxItem[];
    subscription_name: string;
    created_at: string;
    week: number;
    box_has_change: boolean;
};

const fetchPastBoxes = async (subcriptionId: number, week: number) => {
    const token = await getToken();
    return axios.get<PastBoxResponse>(
        `${config.BACKEND_URL}/api/v1/boxes/week_content`,
        {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                week,
                subscription_id: subcriptionId,
                ...getUIDParam(),
            },
        },
    );
};

export const pastBoxesQuery = ({
    subscriptionId,
    week,
}: {
    subscriptionId: number;
    week: number;
}) =>
    useQuery({
        queryKey: ["past-boxes", subscriptionId, week],
        queryFn: () => fetchPastBoxes(subscriptionId, week),
    });
